module.exports = __webpack_public_path__ + "img/levelup-icon-arrow-back.cdf3f1b2.svg";